import { render, staticRenderFns } from "./ObjectivePoints.vue?vue&type=template&id=118f50e0"
import script from "./ObjectivePoints.vue?vue&type=script&lang=js"
export * from "./ObjectivePoints.vue?vue&type=script&lang=js"
import style0 from "./ObjectivePoints.vue?vue&type=style&index=0&id=118f50e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports